import { Component, computed, EventEmitter, inject, Output, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BANK_CONFIG } from 'src/app/bank.config';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { CustomerAccount } from 'src/model/customerAccount.model';

@Component({
  selector: 'app-add-bank-in-account',
  standalone: false,
  templateUrl: './add-bank-in-account.component.html',
  styleUrl: './add-bank-in-account.component.scss',
})
export class AddBankInAccountComponent {
  disabledSubmit = false;

  @Output() addedBank = new EventEmitter<CustomerAccount>();

  protected activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);

  account = signal<CustomerAccount>(new CustomerAccount());
  isOtherBank = computed(() => {
    return !BANK_CONFIG.some(b => b.bankName === this.account().Bank);
  })

  readonly BANK_CONFIG = BANK_CONFIG;

  bankChanged(newValue: string) {
    this.account.update(acc => {
      acc.Bank = newValue !== 'Other' ? newValue : null;
      return Object.assign(new CustomerAccount(), acc);
    });
  }

  submit() {
    const errors = this.account().validate();
    if (errors.length > 0) {
      this.sharedService.openAlert(errors.map(e => `- ${e}`).join('\n'), ALERT_TYPE.DANGER);
      this.disabledSubmit = false;
      return;
    } else {
      this.addedBank.emit(this.account());
      this.reset();
      this.sharedService.openAlert("Successfully added company account", ALERT_TYPE.SUCCESS);
    }
  }

  reset() {
    this.activeModal.close();
  }
}
